import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      attrs: {
        "data-qa": "appointment-documents-info-modal",
        value: _vm.value,
        size: _setup.isMobile ? "fullscreen" : "lg",
        title: _setup.t("Какие документы брать", _setup.options),
        divider: "",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "prependBtn",
          fn: function ({ btnProps }) {
            return [
              _c(
                VBtn,
                _vm._b(
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", false)
                      },
                    },
                  },
                  "v-btn",
                  btnProps,
                  false
                ),
                [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "text-subtitle-1 text--text" }, [
        _vm._v(
          "\n    " + _vm._s(_setup.t("Общие для всех", _setup.options)) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm._l(_setup.listTextItems, function (stepText, stepIndex) {
        return _c(
          "div",
          { key: stepIndex, staticClass: "d-flex align-center py-3" },
          [
            _c(
              "div",
              {
                staticClass:
                  "primary--text text-body-2 d-flex align-center justify-center rounded-circle bg-primary",
                style: {
                  width: "24px",
                  height: "24px",
                },
              },
              [_vm._v("\n      " + _vm._s(stepIndex + 1) + "\n    ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ml-4 text-body-1 text--text" }, [
              _vm._v("\n      " + _vm._s(stepText) + "\n    "),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-subtitle-1 text--text mt-5" }, [
        _vm._v(
          "\n    " + _vm._s(_setup.t("Дополнительные", _setup.options)) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        VExpansionPanels,
        { staticClass: "mt-4", attrs: { multiple: "" } },
        [
          _c(
            VExpansionPanel,
            { staticClass: "text--text" },
            [
              _c(
                VExpansionPanelHeader,
                { attrs: { "expand-icon": "ui-icon-arrow-down" } },
                [
                  _c("div", { staticClass: "text-body-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _setup.t(
                            "Родителю, если фамилии родителя и ребёнка отличаются",
                            _setup.options
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(VExpansionPanelContent, [
                _c("div", { staticClass: "text-body-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t(
                          "Нужен документ, подтверждающий изменение фамилии",
                          _setup.options
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t(
                          "Например, свидетельство о заключении или расторжении брака",
                          _setup.options
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VExpansionPanel,
            { staticClass: "text--text" },
            [
              _c(
                VExpansionPanelHeader,
                { attrs: { "expand-icon": "ui-icon-arrow-down" } },
                [
                  _c("div", { staticClass: "text-body-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _setup.t("Опекуну или попечителю", _setup.options)
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(VExpansionPanelContent, [
                _c("div", { staticClass: "text-body-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t(
                          "Нужно постановление суда или органов опеки и попечительства, подтверждающее ваш статус",
                          _setup.options
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VExpansionPanel,
            { staticClass: "text--text" },
            [
              _c(
                VExpansionPanelHeader,
                { attrs: { "expand-icon": "ui-icon-arrow-down" } },
                [
                  _c("div", [
                    _c("div", { staticClass: "text-body-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _setup.t("Другому сопровождающему", _setup.options)
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-body-2 text-secondary--text" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _setup.t(
                                "бабушка, дедушка, тётя, дядя, няня, брат или сестра, друг семьи и прочие",
                                _setup.options
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                VExpansionPanelContent,
                [
                  _c("div", { staticClass: "text-body-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _setup.t(
                            "Нужна нотариальная доверенность на представление интересов ребёнка",
                            _setup.options
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    _setup.BannerInfo,
                    { staticClass: "mt-2", attrs: { "inner-atom-indent": 0 } },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _setup.t(
                                "Требования к доверенности",
                                _setup.options
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-body-2 mt-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _setup.t(
                                "В ней должно быть указано, что представитель имеет право:",
                                _setup.options
                              )
                            ) +
                            "\n            "
                        ),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _setup.t(
                                  "получать любую информацию относительно состояния здоровья ребёнка",
                                  _setup.options
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _setup.t(
                                  "получать справки, выписки, рецепты и иные документы",
                                  _setup.options
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _setup.t(
                                  "принимать решения по вопросам медицинских обследований и медицинских вмешательств",
                                  _setup.options
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _setup.t(
                                    "подписывать все виды информированных согласий,",
                                    _setup.options
                                  )
                                ) +
                                "\n                " +
                                _vm._s(
                                  _setup.t(
                                    "в том числе на медицинские вмешательства и вакцинацию.",
                                    _setup.options
                                  )
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }